// frontend/src/components/admin/AdminSidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FiHome,
  FiShoppingBag,
  FiPackage,
  FiFileText,
  FiBarChart2,
  FiSettings,
  FiLogOut,
  FiShoppingCart,
  FiGrid,
  FiDollarSign,
  FiShield,
  FiUserCheck
} from 'react-icons/fi';

const AdminSidebar = ({ user, isOpen, onClose, onLogout }) => {
  const location = useLocation();

  const navItems = [
    { path: '/admin/dashboard', icon: FiHome, label: 'Хянах самбар' },
    { path: '/admin/pos', icon: FiShoppingCart, label: 'Борлуулалт (POS)' },
    { path: '/admin/products', icon: FiShoppingBag, label: 'Бараа бүтээгдэхүүн' },
    { path: '/admin/categories', icon: FiGrid, label: 'Ангилал' },
    { path: '/admin/inventory', icon: FiPackage, label: 'Агуулах' },
    { path: '/admin/orders', icon: FiFileText, label: 'Захиалга' },
    { path: '/admin/customers', icon: FiUserCheck, label: 'Харилцагч' },
    { path: '/admin/bank-accounts', icon: FiDollarSign, label: 'Банкны данс' },
    { path: '/admin/reports', icon: FiBarChart2, label: 'Тайлан' },
    { path: '/admin/users', icon: FiShield, label: 'Хэрэглэгч' },
    { path: '/admin/settings', icon: FiSettings, label: 'Тохиргоо' }
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={onClose}
        ></div>
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
        {/* Navigation */}
        <nav className="sidebar-nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-link ${isActive ? 'sidebar-link-active' : ''}`}
                onClick={onClose}
              >
                <Icon className="sidebar-icon" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* User Info */}
        <div className="sidebar-user-info">
          <div className="flex items-center justify-between">
            <div className="flex items-center min-w-0 flex-1">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-blue-700 font-semibold text-sm">
                  {user?.full_name?.charAt(0).toUpperCase()}
                </span>
              </div>
              <div className="ml-3 min-w-0 flex-1">
                <p className="text-sm font-semibold text-gray-900 truncate">
                  {user?.full_name}
                </p>
                <p className="text-xs text-gray-500 capitalize">{user?.role_name}</p>
              </div>
            </div>
            <button
              onClick={onLogout}
              className="text-gray-600 hover:text-red-600 transition-colors flex-shrink-0 ml-2"
              title="Гарах"
            >
              <FiLogOut size={18} />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;